import React from 'react'
import Page from '../../components/layout/page.component'

export default function LastSearches(){
    return <Page title='Last Searches' />
}